import {
  type LandingLocale,
  type LandingTestimonialItem,
  landingPageContentRepository,
} from '../../shared/content/landingContent.js';
import { cloneEditorValue, type LandingEditorProject } from '../../shared/editor/landingEditorTypes.js';
import type { LandingEditorElementDefinition } from '../editor/landingEditorRegistry.js';

const templateByLocale: Record<LandingLocale, LandingTestimonialItem> = {
  de: {
    quote: '„Hier steht die persönliche Erfolgsgeschichte.“',
    author: 'Name der Person',
    role: 'Position · Unternehmen',
    imageAlt: 'Portrait der Person',
    logoAlt: 'Unternehmenslogo',
  },
  tr: {
    quote: '“Kişisel başarı hikâyesi burada yer alır.”',
    author: 'Kişinin adı',
    role: 'Pozisyon · Şirket',
    imageAlt: 'Kişinin portresi',
    logoAlt: 'Şirket logosu',
  },
  en: {
    quote: '“The personal success story goes here.”',
    author: 'Person’s name',
    role: 'Position · Company',
    imageAlt: 'Portrait of the person',
    logoAlt: 'Company logo',
  },
};

export const appendTestimonial = (project: LandingEditorProject, locale: LandingLocale) => {
  const insertionIndex = project.content[locale].story.testimonials.length;
  const nextProject = cloneEditorValue(project);
  for (const localeOption of landingPageContentRepository.locales) {
    nextProject.content[localeOption].story.testimonials.splice(
      insertionIndex,
      0,
      cloneEditorValue(templateByLocale[localeOption]),
    );
  }
  return { nextProject, insertionIndex };
};

export const testimonialDefinitionFor = (
  definition: LandingEditorElementDefinition | undefined,
  definitionById: Readonly<Record<string, LandingEditorElementDefinition>>,
) => {
  let current = definition;
  while (current) {
    if (/^story\.testimonial\.\d+$/.test(current.id)) return current;
    current = current.parentId ? definitionById[current.parentId] : undefined;
  }
  return undefined;
};
